<script setup lang="ts">
import debounce from 'lodash/debounce'
import SearchBar from './SearchBar.vue'

const emit = defineEmits(['close'])
const { t } = useLocale()

const onClose = () => {
  emit('close')
}

const searchBar = ref<InstanceType<typeof SearchBar> | null>(null)
const buttonBottom = ref(24)

const localizeMe = async () => {
  await searchBar.value?.searchFromLocation()
}

const viewportHandler = () => {
  const viewport = window.visualViewport
  if (viewport) {
    const offsetTop =
      viewport.height - document.body.getBoundingClientRect().height + viewport.offsetTop
    buttonBottom.value = 24 + Math.abs(offsetTop)
  }
}

const viewportHandlerDebounced = debounce(viewportHandler, 50)

onMounted(() => {
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', viewportHandlerDebounced)
    window.visualViewport.addEventListener('scroll', viewportHandlerDebounced)
  }
})

onBeforeUnmount(() => {
  if (window.visualViewport) {
    window.removeEventListener('resize', viewportHandlerDebounced, false)
    window.removeEventListener('scroll', viewportHandlerDebounced, false)
  }
})
</script>

<template>
  <ModalCenter :add-close-button="false" :content-full="true" @close="onClose">
    <template #header>
      <div class="flex min-h-[2.5rem] w-full flex-row items-center">
        <Chevron fill="#292929" class="h-6 w-6 -rotate-180 cursor-pointer" @click="onClose" />
      </div>
    </template>
    <template #content>
      <section>
        <div>
          <SearchBar
            ref="searchBar"
            :modal="true"
            :absolute-places="true"
            :search-screen="true"
            @on-search="onClose"
          />
        </div>

        <!-- LocateMe floating button -->
        <div
          class="absolute left-0 right-0 z-10 px-4 transition-[bottom]"
          :style="{ bottom: `${buttonBottom}px` }"
        >
          <McdButton is-primary class="w-full py-3 text-sm" @on-click="localizeMe">
            <div class="flex flex-row items-center justify-center gap-2">
              <img src="/images/icons/locateMe.svg" alt="locateMe" />
              <span class="block">{{ t('home.searchLocateMe') }}</span>
            </div>
          </McdButton>
        </div>
      </section>
    </template>
  </ModalCenter>
</template>
